// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x6-8";
export var container = "_x6-0";
export var radioDot = "_x6-5";
export var radioDotSelected = "_x6-6";
export var row = "_x6-1";
export var rowFirst = "_x6-2";
export var rowLast = "_x6-3";
export var rowSelected = "_x6-4";
export var strikethrough = "_x6-7";